import { Button } from "@babackapp/customer-ui/components/button";
import { XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { postToParent } from "../lib/shop-now-embed";
import { LanguageSelector } from "./language-selector";

// Standalone tabs and the merchant preview have no embed script to answer the
// close message, so the button would be a dead end there.
const isEmbedded = window.parent !== window;

/**
 * The fixed row every page keeps in its top-right corner: language, then close.
 * Anything absolutely positioned near the top has to leave room for it, see the
 * stepper bar in `line-item/layout.tsx`.
 */
export function WidgetChrome() {
  const { t } = useTranslation("return-widget-v3");

  return (
    <div className="absolute top-6 right-6 z-30 flex items-center gap-1">
      <LanguageSelector />
      {isEmbedded && (
        <Button
          type="button"
          size="icon"
          variant="ghost"
          aria-label={t("common.close")}
          onClick={() => postToParent({ type: "WIDGET_CLOSE" })}
        >
          <XIcon />
        </Button>
      )}
    </div>
  );
}
